import Vue from "vue";
import Router from "vue-router";
// import cashier from '@/views/cashier'
import hello from "@/components/hello";
import hi from "@/components/hi";
import navigation from "@/components/navigation";
import order from "@/views/order";

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: "/",
            name: "login", //登录
            component: () => import("../views/login.vue"),
        },
        {
            path: "/a",
            name: "HelloWorld",
            component: hi,
        },
        {
            path: "/b",
            name: "HelloWorld",
            component: hello,
        },
        {
            path: "/madt",
            name: "madt",
            component: () => import("../views/madt.vue"),
        },
				{
					path: "/fenjian",
					name: "fenjian", //分拣
					component: () => import("../views/FenJianPrint.vue"),
				},
        {
            path: "/nav",
            name: "nav",
            redirect: "/nav/cashier",
            component: navigation,
            children: [
                {
                    path: "cashier",
                    name: "cashier", //收银
                    component: () => import("../views/cashier.vue"),
                    // meta: {
                    //     keepAlive: true
                    // }
                },
                {
                    path: "commodity",
                    name: "commodity", //商品
                    component: () => import("../views/commodity.vue"),
										// meta: {
										//     keepAlive: true
										// }
                },
                {
                    path: "printd",
                    name: "printd", //
                    component: () => import("../views/print.vue"),
                },
                {
                    path: "order",
                    name: "order", //订单
                    component: () => import("../views/order.vue"),
                    // component: order,
                },
                {
                    path: "member",
                    name: "member",
                    redirect: "member/index",
                    component: () => import("@/views/member/layout.vue"),
                    children: [
                        {
                            path: "index",
                            name: "memberList",
                            component: () => import("@/views/member/index.vue"),
                        },
                        {
                            path: "detail",
                            name: "memberDetail",
                            component: () => import("@/views/member/detail.vue"),
                        },
                    ],
                },
                {
                    path: "shift",
                    name: "shift",
                    component: () => import("@/views/shift.vue"),
                },
                {
                    path: "report",
                    name: "report",
                    component: () => import("@/views/report.vue"),
                },
                {
                    path: "statment",
                    name: "statment",
                    component: () => import("@/views/statment.vue"),
                },

                {
                    path: "system-set",
                    name: "systemSet",
                    component: () =>
                        import(
              /* webpackChunkName: "group-system-set" */ "@/views/set/index.vue"
                        ),
                    meta: {
                        title: "系统设置 - 收银管理系统",
                        name: "系统设置",
                    },
                },
                {
                    path:"daily",
                    name:"日报表",
                    component: () => import("@/views/report/daily.vue"),
                },
                {
                    path: "allReport",
                    name: "allReport",
                    component: () => import("@/views/report/allReport/index.vue"),
                },
                {
                    path: "today",
                    name: "today",
                    component: () => import("@/views/report/index.vue"),
                },
                {
                    path: "dailySales",
                    name: "dailySales",
                    component: () => import("@/views/report/dailySales/index.vue"),
                },
                {
                    path: "cashFlow",
                    name: "cashFlow",
                    component: () => import("@/views/report/cashFlow/index.vue"),
                },
                {
                    path: "agencySell",
                    name: "agencySell",
                    component: () => import("@/views/report/agencySell/index.vue"),
                },
                {
                    path: "lotDetail",
                    name: "lotDetail",
                    component: () => import("@/views/report/lotDetail/index.vue"),
                },
                {
                    path: "abnormalHandle",
                    name: "abnormalHandle",
                    component: () => import("@/views/report/abnormalHandle/index.vue"),
                },
            ],
        },
        {
            path: "/order",
            name: "order",
            component: order,
        },
        {
            path: "/print",
            name: "print",
            component: () =>
                import(/* webpackChunkName: "group-print" */ "@/views/set/print.vue"),
            meta: {
                title: "标签打印 - 收银管理系统",
                name: "标签打印",
            },
        },
        // {
        //   path: "/qrcode",
        //   name: "qrcode",
        //   component: () =>
        //     import(/* webpackChunkName: "group-print" */ "@/views/set/qrcode.vue"),
        //   meta: {
        //     title: "扫码支付 - 收银管理系统",
        //     name: "扫码支付",
        //   },
        // },
        {
            path: "/print-demo",
            name: "printDemo",
            component: () =>
                import(
          /* webpackChunkName: "group-print-demo" */ "@/views/demo/index.vue"
                ),
            meta: {
                title: "打印demo - 收银管理系统",
                name: "打印demo",
            },
        },
    ],
});



// WEBPACK FOOTER //
// ./src/router/index.js